import Image from '@anm/components/image/Image';
import noop from '@anm/helpers/noop';
import { toUrlParams } from '@anm/helpers/parseParams';
import { FC } from 'react';

import Container from './Container';
import { strWindowSettings } from './helpers';
import { ShareProps } from './types';

const shareOnEmail = ({ url, title, onShare = noop }: ShareProps) => {
  const query = toUrlParams({
    body: url,
    subject: title
  });
  const emailUrl = `mailto:?${query}`;
  onShare('email');

  window.open(emailUrl, 'EmailWindow', strWindowSettings);
};

const EmailShare: FC<ShareProps> = props => (
  <Container onClick={() => shareOnEmail(props)}>
    <Image src="images/icons/share/email-icon.svg" />
    <h5>Email</h5>
  </Container>
);

export default EmailShare;
